<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  conversationId: { type: [Number, String], required: true },
});

const emit = defineEmits(['open-panel']);

const store = useStore();
const { t } = useI18n();

const ticket = computed(() =>
  store.getters['tickets/getTicketByConversationId'](Number(props.conversationId))
);

const stateLabel = computed(() => {
  if (!ticket.value?.state) return '';
  const key = ticket.value.state.toUpperCase();
  return t(`TICKETING.STATES.${key}`, key);
});
</script>

<template>
  <div v-if="ticket" class="flex items-center gap-2">
    <button
      type="button"
      class="text-xs font-medium px-2 py-0.5 rounded-md bg-n-brand/10 text-n-brand"
      @click="emit('open-panel')"
    >
      {{ ticket.ticket_number }} · {{ stateLabel }}
    </button>
  </div>
</template>
